// modified from portal project (from release/4.0)
// IdeaFinancial.Web/projects/portal/src/app/mfa/mfa-routing.module.ts
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  AppBarCloseAction,
  AppBarComponent,
  AppBarTitleComponent,
  AppFooterComponent,
  AppPageComponent,
} from "common";
import { BrokerCurrentResolver } from "../broker/infrastructure/broker.resolver";
import { WebPaths } from "../shared/SharedConstants";
import { ProfileComponent } from "./profile.component";
import { OAuthGuard } from "../../guards/oauth.guard";

const routes: Routes = [
  {
    path: WebPaths.Profile.slice(1),
    title: "Profile – Idea Financial Partner",
    component: AppPageComponent,
    canActivate: [OAuthGuard],
    data: {
      appPage: {
        contentClass: "simple",
        contentAlignment: "center-start",
        contentWithoutPadding: true,
      },
      appBar: {
        stickyDisabled: true,
        closeAction: AppBarCloseAction.BACK,
        logoHidden: true,
        containerClass: "start-center",
      },
      appBarTitle: {
        content: "Profile",
      },
    },
    resolve: {
      brokerUser: BrokerCurrentResolver,
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: AppBarTitleComponent,
          },
        ],
      },
      {
        path: "",
        component: ProfileComponent,
      },
      {
        path: "",
        outlet: "app-footer",
        component: AppFooterComponent,
        data: {
          appFooter: {
            full: true,
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
